import { AppBar, Box, Container, Typography, useMediaQuery, useScrollTrigger } from "@mui/material";
import React from "react";
import { Timestamp } from "firebase/firestore";
import { Txt } from "./Routes/Localized";
import LangLink from "./Localization/LangLink";
import { theme } from "./Resources/Design/theme";

//48
export const fontTitleLarge = {
    fontSize: { xs: '26px', sm: '26px', md: '48px' },
    lineHeight: { xs: '32px', sm: '32px', md: '58px' },
    [theme.breakpoints.down('md')]: {
        fontWeight: 750
    },
};
//40
export const fontTitle = {
    fontSize: { xs: '26px', sm: '26px', md: '40px' },
    lineHeight: { xs: '32px', sm: '32px', md: '48px' },
    [theme.breakpoints.down('md')]: {
        fontWeight: 750
    },
};
//32
export const fontTitleSmall = {
    fontSize: { xs: '26px', sm: '26px', md: '32px' },
    lineHeight: { xs: '32px', sm: '32px', md: '40px' },
    [theme.breakpoints.down('md')]: {
        fontWeight: 750
    },
};
//26
export const fontTitleXS = {
    fontSize: '26px',
    lineHeight: '34px',
};
//20
export const fontTextLarge = {
    fontSize: '20px',
    lineHeight: '28px',
};
//18
export const fontText = {
    fontSize: { xs: '20px', sm: '20px', md: '18px' },
    lineHeight: { xs: '26px', sm: '26px', md: '26px' },
    [theme.breakpoints.down('md')]: {
        fontWeight: 750
    },
};
//18
export const fontTextHead = {
    fontSize: { xs: '14px', sm: '14px', md: '18px' },
    lineHeight: { xs: '22px', sm: '22px', md: '26px' },
    [theme.breakpoints.down('md')]: {
        fontWeight: 500
    },
};
//16
export const fontTextSmall = {
    fontSize: { xs: '14px', sm: '14px', md: '16px' },
    lineHeight: { xs: '22px', sm: '22px', md: '24px' },
};
//14
export const fontLink = {
    fontSize: '14px',
    lineHeight: '22px',
};

export const greenButton = {
    fontFamily: 'inter',
    backgroundColor: "#03BD46",
    boxShadow: 'none',
    transition: 'background-color 0.3s ease',
    '&:hover': {
        backgroundColor: '#02A13C',
        boxShadow: 'none',
    },
};

export const blueButton = {
    fontFamily: 'inter',
    backgroundColor: "#0165F4",
    boxShadow: 'none',
    transition: 'background-color 0.3s ease',
    '&:hover': {
        backgroundColor: '#015BE0',
        boxShadow: 'none',
    },
};

export function Logo({ sx = {}, sxText = {}, car = "#011949", skaut = "#4534C2", to = "/" }) {
    const isLink = !Boolean(to == null);
    const linkProps = {
        to,
    };

    return <Box name='CarSkaut'
        component={isLink ? LangLink : 'div'}
        sx={{ textDecoration: 'none', ...sx }}
        {...(isLink && linkProps)}
    >
        <Typography sx={{
            fontFamily: 'alexandria', fontWeight: 700, fontSize: { xs: '20px', sm: '20px', md: '30px' }, lineHeight: '32px',
            textAlign: 'left', ...sxText
        }}>
            <span style={{ color: car }}>Car</span><span style={{ color: skaut }}>Skaut</span>
        </Typography>
    </Box>
}

export function Bar({
    boxSetHeight,
    barHeight = 50,
    colors = {
        top: '#F8F8FC',
        main: '#FFF',
    },
    threshold = 0,
    children
}) {
    const small = useTablet();
    const scroll = useScrollTrigger({ disableHysteresis: true, threshold });
    const boxHeight = boxSetHeight ?? (small ? 60 : 80);

    return <>
        <Box sx={{ flexGrow: 1, mb: '16px' }}>
            <AppBar position="fixed" elevation={0} sx={{
                bgcolor: 'transparent',
                height: `${boxHeight}px`,
                zIndex: (theme) => theme.zIndex.drawer + 1
            }}>
                <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                    <Box sx={{ position: 'absolute', top: 0, width: '100%', height: '90%', bgcolor: colors.top || "#FFFFFF", zIndex: 1, }} />
                    <Container maxWidth='xl' sx={{
                        height: '100%', display: 'flex', flexDirection: 'column',
                        alignItems: 'flex-end',
                        alignContent: 'flex-end',
                        minWidth: '340px'
                    }}>
                        <Box sx={{ width: '100%', height: `${boxHeight - barHeight + 8}px`, bgcolor: colors.top || "#FFFFFF", mb: '-8px' }} />
                        <Box sx={{ height: `${barHeight}px`, width: '100%', bgcolor: colors.main || "#FFFFFF", borderRadius: '10px', boxShadow: 'none', border: `1px solid #F7F7F7`, zIndex: 2 }}>
                            <Box sx={{
                                width: '100%', height: '100%', px: { xs: '16px', sm: '16px', md: '30px' },
                                display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center',
                            }}>
                                <Logo sx={{ mr: '10px' }} />
                                {children}
                            </Box>
                        </Box>
                    </Container>
                </Box>
            </AppBar>
            <Box sx={{ height: `${boxHeight}px`, mb: '16px' }} />
        </Box>
    </>;
}

// import { ReactComponent as SomeName } from "./SomeName.svg";
export const SvgComponent = ({ svg: SvgComp, style = {}, sx = {} }) => {
    const editedIcon = React.cloneElement(<SvgComp />, {
        style: {
            display: 'block',
            ...style,
        },
    });
    return <Box sx={{ ...sx }}>{editedIcon}</Box>;
};

export const fullCenter = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center'
}

export function dMyyyyToTimestamp(dateStr) {
    const [day, month, year] = dateStr.split(".").map(Number);

    // Create date at midnight local time
    const date = new Date(year, month - 1, day);

    return Timestamp.fromDate(date);
}

export const timestampToDMyyyy = (input) => {
    if (!input) return "";

    let date;

    if (typeof input === "string") {
        return input;
    }

    // Firestore Timestamp (has toDate)
    if (typeof input.toDate === "function") {
        date = input.toDate();
    }
    // Serialized Firestore timestamp
    else if (input.seconds !== undefined) {
        date = new Date(input.seconds * 1000);
    }
    // Already a Date
    else if (input instanceof Date) {
        date = input;
    }
    // String or number
    else {
        date = new Date(input);
    }

    // Invalid date check
    if (isNaN(date.getTime())) return "";

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
};

export function getLocalDateTime(d = new Date()) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
}

export const scrollbarDesign = {
    "&::-webkit-scrollbar": {
        display: "block",
        height: "8px",
        width: "8px",
        scrollbarWidth: "thin",
    },
    "&::-webkit-scrollbar-track": {
        display: "block",
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        scrollbarWidth: "thin",
    },
    "&::-webkit-scrollbar-thumb": {
        display: "block",
        backgroundColor: "rgba(0,0,0,0.3)",
        outline: "none",
        borderRadius: "16px",

        scrollbarWidth: "thin",
    },
    scrollbarWidth: "thin",
};


export function titleCase(str) {
    if (typeof str !== "string" || !str.trim()) {
        return str;
    }

    return str
        .toLocaleLowerCase()
        .trim()
        .replace(/(^|\s)\p{L}/gu, match => match.toLocaleUpperCase());
}

export function roundFixed(num) {
    if (num === 0) return 0;
    const final = +(Math.round(parseFloat(num) + Number.EPSILON + "e+2") + "e-2");
    return final.toFixed(2);
}

export const footer_navigation = [
    { title: <Txt id={"23011"} />, link: 'privacy' },
    { title: <Txt id={"23012"} />, link: 'terms' },
    { title: <Txt id={"23013"} />, link: 'cookies' },
    { title: <Txt id={"23014"} />, link: 'terms#part6' },
];

export const useMobile = () => {
    const mobile = useMediaQuery("(max-width:600px)");
    return mobile;
}

export const useTablet = () => {
    const mobile = useMediaQuery("(max-width:900px)");
    return mobile;
}

export const usePC = () => {
    const isDesktop = useMediaQuery("(min-width:901px)");
    return isDesktop;
}

export const isArray = (v) => {
    return Boolean(v && Array.isArray(v) && v.length > 0);
}

export const APP_TEST_MODE = false;

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
